import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unautorized',
  templateUrl: './unautorized.component.html',
  styleUrls: ['./unautorized.component.less']
})
export class UnautorizedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
